import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { share, switchMap } from 'rxjs/operators';
import { FORM_PATH_TOKEN, FrameContext, IElementManifestService, IFormElementManifestService, IFormElementManifest, IElementManifest, FORM_ELEMENT_MANIFEST_SERVICE_TOKEN } from '@farris/devkit';
import { BasePathService } from '@farris/rtf';

@Injectable()
export class ElementManifestService implements IElementManifestService {
  private static mainfests = new Map<string, Observable<any>>();
  constructor(
    private injector: Injector,
    private frameContext: FrameContext,
    private httpClient: HttpClient,
    @Inject(FORM_PATH_TOKEN) private modulePath,
    @Inject(FORM_ELEMENT_MANIFEST_SERVICE_TOKEN) private formElementManifestService: IFormElementManifestService) { }

  public load(): Observable<any> {
    if (this.modulePath.endsWith('\/')) {
      this.modulePath = this.modulePath.substring(0, this.modulePath.length - 1);
    }

    return this.formElementManifestService.load().pipe(
      switchMap((formManifest: IFormElementManifest) => {
        const viewRules = formManifest.viewRules;
        const expressionManifest = viewRules.find((element: IElementManifest) => element.ns === this.frameContext.namespace);
        if (expressionManifest) {
          const path = BasePathService.convertPath(`${this.modulePath}/viewrules/${expressionManifest.path}?version=${new Date().valueOf().toString()}`);
          const key = BasePathService.convertPath(`${this.modulePath}/viewrules/${expressionManifest.path}`);
          const request$ = ElementManifestService.mainfests.get(key);
          if (request$) {
            return request$;
          } else {
            const req$ = this.httpClient.get(path, { responseType: 'json' }).pipe(share());
            ElementManifestService.mainfests.set(key, req$);
            return req$;
          }
        } else {
          return of(null);
        }
      })
    );
  }
}
